import { createFileRoute } from "@tanstack/react-router";
import { UserGroupsPage } from "@/features/admin/user-groups-page";
import { ensureAdminAccess } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/konfiguracja/grupy-uzytkownikow")({
	// Parytet z backendem: `/admin/org-groups` bramkuje `require_admin`
	// (org_groups.rs), więc guard trasy też jest adminowy, nie super_adminowy.
	beforeLoad: async () => {
		await ensureAdminAccess();
	},
	component: UserGroupsPage,
});
